import { createRoot } from 'react-dom/client';
import '@/i18n';
import '@/utils/dateTime/setup';
import App from '@/components/App';
import { enableMocking } from '@/mocks';

import '@fontsource/geologica/greek-300.css';
import '@fontsource/geologica/greek-400.css';
import '@fontsource/geologica/greek-500.css';
import '@fontsource/geologica/greek-600.css';
import '@fontsource/geologica/latin-300.css';
import '@fontsource/geologica/latin-400.css';
import '@fontsource/geologica/latin-500.css';
import '@fontsource/geologica/latin-600.css';

enableMocking().then(() => {
  createRoot(document.getElementById('root') as HTMLElement).render(<App />);
});
